import {booleanComparator, booleanFilterCellRenderer, nullableBoolCellRenderer, booleanCleaner} from "../helpers/boolean";

export let nullableBoolCol = {
	editable: true,
	cellRenderer: nullableBoolCellRenderer,
	cellEditor: 'agRichSelectCellEditor',
	cellEditorParams: {
		values: [true, false, null],
		cellRenderer: nullableBoolCellRenderer
	},
	cellStyle: function (params) {
		let valueCleaned = booleanCleaner(params.value);
		if (valueCleaned === true) {
			return {
				textAlign: 'center',
				backgroundColor: '#cee9d4'
			};
		} else if (valueCleaned === null) {
			return {
				textAlign: 'center',
				backgroundColor: '#999',
			};
		} else {
			return {
				textAlign: 'center',
				backgroundColor: '#e5cbcb',
			};
		}
	},
	filter: 'agSetColumnFilter',
	comparator: booleanComparator,
	resizable: true,
	filterParams: {
		cellRenderer: booleanFilterCellRenderer,
		selectAllOnMiniFilter: true,
		newRowsAction: 'keep',
		clearButton: true
	},
	width: 50,
}
